var document = require('./_global').document;
module.exports = document && document.documentElement;



//////////////////
// WEBPACK FOOTER
// ./~/react-app-polyfill/~/core-js/modules/_html.js
// module id = 1686
// module chunks = 0